import React, { useState } from 'react';
import DOMPurify from 'dompurify';
// import Popovermenu from '../components/Popover';
import { Tooltip, Button, Avatar } from '@mantine/core';
import downicon from 'assets/icons/downicon3.svg';
import dislike from 'assets/icons/unFavIcon2.svg';
import like from 'assets/icons/heartFillIcon.svg';
import forward from 'assets/icons/forwardicon.svg';
import { ReactComponent as Discard } from 'assets/icons/junkicon.svg';
import { ReactComponent as Forward } from 'assets/icons/forwardicon2.svg';
import { ReactComponent as Send } from 'assets/icons/senticon3.svg';
// import { ReactComponent as Voice } from 'assets/icons/talkbutton.svg';
import { ReactComponent as Restore } from 'assets/icons/restoreIcon.svg';

// import menuicon from 'assets/icons/menudots.svg';
import dayjs from 'dayjs';
import Composemail from '../components/Composemail';
import useUpdateMailStatus from '../hooks/useUpdateMailStatus';
import Deletechat from '../components/deletechat';

import { ReactComponent as Backarrow } from 'assets/icons/backArrowIcon.svg';

const Displayemail = (props) => {
  const { data, setIsUpdated } = props;
  const mails = data;
  // console.log('mails', mails);
  const useupdatemailStatus = useUpdateMailStatus();

  const [isToExpand, setIsToExpand] = useState(false);
  const [isccExpand, setIsccExpand] = useState(false);
  const [opened, setOpened] = useState(false);
  const [action, setAction] = useState('');

  const [isDelete, setIsDelete] = useState(false);

  return (
    <div className='pb-4'>
      {mails?.map((mail) => {
        return (
          <div className='py-4 w-full ' key={mail?.id}>
            <div className='flex justify-start gap-x-4 bg-F8F7F7 items-center mx-4 p-1 '>
              <Avatar
                src={
                  mail?.mail_type === 'Draft' || mail?.mail_type === 'Sent'
                    ? mail?.to[0]?.profile_pic
                    : mail?.from_addr[0]?.profile_pic
                }
                color='red'
                radius='xl'
                size={'36px'}
                classNames={{ root: 'border border-primary' }}
              >
                {mail?.mail_type === 'Draft' || mail?.mail_type === 'Sent'
                  ? mail?.to[0]?.name?.[0]?.toUpperCase()
                  : mail?.from_addr[0]?.name?.[0]?.toUpperCase()}
              </Avatar>
              <div className='flex gap-x-4  w-full'>
                <div className='w-full flex-col'>
                  <div className='flex w-full justify-start  '>
                    <div className='flex gap-x-1 items-center'>
                      <h1 className='font-bold text-xs text-202124 cursor-pointer 2xl:text-sm 3xl:text-lg'>
                        {mail?.mail_type === 'Draft' ||
                        mail?.mail_type === 'Sent'
                          ? `To: 
              ${mail?.to[0]?.name}`
                          : mail?.from_addr[0]?.name}
                      </h1>
                      {
                        <p className='text-xs text-585858 cursor-pointer 2xl:text-sm 3xl:text-lg'>
                          &lt;
                          {mail?.mail_type === 'Draft' ||
                          mail?.mail_type === 'Sent'
                            ? mail?.to[0]?.email
                            : mail?.from_addr[0]?.email}
                          &gt;
                        </p>
                      }
                    </div>
                  </div>
                  <div className='flex gap-x-2 2xl:gap-x-3 3xl:gap-x-4 items-start w-[100%]  justify-between '>
                    <div className='flex gap-x-4 '>
                      <div className='flex items-start gap-y-1 gap-x-1 flex-col '>
                        {
                          //To div
                        }
                        <div className='w-full flex gap-x-1 items-start'>
                          <p className='font-medium text-xs text-585858 2xl:text-sm 3xl:text-lg'>
                            To: {!isToExpand ? mail?.to[0]?.email : ''}
                          </p>

                          {isToExpand && (
                            <div className='flex flex-col self-start justify-between m-0 p-0'>
                              {mail?.to?.map((mail) => {
                                return (
                                  <p
                                    className='font-medium text-xs text-585858 2xl:text-sm 3xl:text-lg'
                                    key={mail?.email}
                                  >
                                    {mail?.email};
                                  </p>
                                );
                              })}
                            </div>
                          )}
                          {mail?.to.length > 1 && (
                            <img
                              src={downicon}
                              alt='down'
                              className={`${
                                isToExpand ? 'rotate-180' : ''
                              }   w-3 3xl:w-4 translate-y-1 cursor-pointer`}
                              onClick={() => setIsToExpand(!isToExpand)}
                            ></img>
                          )}
                        </div>
                        {
                          //Cc div
                        }
                        {mail?.cc[0] && (
                          <div className='w-full flex gap-x-1 items-start '>
                            <p
                              className={` font-medium text-xs text-585858 2xl:text-sm 3xl:text-lg`}
                            >
                              Cc: {!isccExpand ? mail?.cc[0]?.email : ''}
                            </p>
                            {isccExpand && (
                              <div className='flex flex-col self-start justify-between m-0 p-0'>
                                {mail?.cc?.map((mail) => {
                                  return (
                                    <p
                                      className='font-medium text-xs text-585858 2xl:text-sm 3xl:text-lg'
                                      key={mail?.email}
                                    >
                                      {mail?.email};
                                    </p>
                                  );
                                })}
                              </div>
                            )}
                            {mail?.cc.length > 1 && (
                              <img
                                src={downicon}
                                alt='down'
                                className={`${
                                  isToExpand ? 'rotate-180' : ''
                                }   w-3 3xl:w-4 translate-y-1 cursor-pointer`}
                                onClick={() => setIsccExpand(!isccExpand)}
                              ></img>
                            )}
                          </div>
                        )}
                      </div>

                      <p className='text-xs text-67A1EF opacity-50 cursor-not-allowed underline  2xl:text-sm 3xl:text-lg'>
                        Unsubscribe
                      </p>
                    </div>

                    <h1 className='font-[Roboto] text-xs text-585858 2xl:text-sm 3xl:text-lg'>
                      {dayjs(mail?.created_time).format('ddd,MMM hh:mm A')}
                    </h1>
                    <div className='flex  items-start gap-x-1 justify-center'>
                      <Tooltip
                        label={
                          mail?.is_favorite
                            ? 'Remove from favourite'
                            : 'Add to favourite'
                        }
                      >
                        <img
                          onClick={() => {
                            useupdatemailStatus.mutate({
                              id: mail?.id,
                              favorite: mail?.is_favorite ? false : true,
                            });
                            setIsUpdated((prev) => !prev);
                          }}
                          src={mail?.is_favorite ? like : dislike}
                          alt='icons'
                          className='w-5 mx-0.5 cursor-pointer 2xl:w-6 3xl:w-8'
                        />
                      </Tooltip>

                      <Tooltip label='Forward' withArrow>
                        <img
                          onClick={() => {
                            setAction('forward');
                            setOpened(true);
                          }}
                          src={forward}
                          alt='icons'
                          className='w-5 mx-0.5 -translate-y-1 cursor-pointer 2xl:w-6 3xl:w-8'
                        />
                      </Tooltip>
                      {/* <Popovermenu icon={menuicon} mail={mail} /> */}
                      {/*  <Voice className='w-6  -translate-y-2 cursor-not-allowed 2xl:w-12 3xl:w-16' /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='flex  flex-col mt-2 p-1 pb-3 mx-4  h-[50vh] xl:h-[53vh] 2xl:h-[53vh] 3xl:h-[57vh] overflow-y-scroll scroller  bg-FEFEFE'>
              <div className='w-full '>
                <h1 className='text-18 font-semibold text-222222  pb-2'>
                  {mail?.subject ? mail?.subject : '(No subject)'}
                </h1>
              </div>
              <div
                className=' text-justify'
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(mail?.body),
                }}
              ></div>
              {mail?.mail_type === 'Draft' && (
                <div className='flex flex-row gap-x-4 items-center mt-auto'>
                  <Button
                    onClick={() => setOpened(true)}
                    rightIcon={<Send className='w-4 h-4 ' />}
                    variant='gray'
                    className='3xl:text-2xl 2xl:text-lg bg-primary text-white'
                  >
                    Send
                  </Button>
                  <Button
                    onClick={() => setIsDelete(true)}
                    rightIcon={<Discard className='w-4 h-4 ' />}
                    variant='gray'
                    className='3xl:text-2xl 2xl:text-lg text-primary border-primary border'
                  >
                    Discard
                  </Button>
                </div>
              )}
              {mail?.mail_type === 'Deleted' && (
                <div className='flex flex-row gap-x-4 items-center mt-auto'>
                  <Button
                    leftIcon={<Restore className='w-4 h-4 rotate-180' />}
                    variant='gray'
                    className='3xl:text-2xl 2xl:text-lg bg-primary text-white'
                    disabled
                  >
                    Restore
                  </Button>
                  <Button
                    onClick={() => setIsDelete(true)}
                    rightIcon={<Discard className='w-4 h-4 ' />}
                    variant='gray'
                    className='3xl:text-2xl 2xl:text-lg text-primary border-primary border'
                  >
                    Delete Permanently
                  </Button>
                </div>
              )}
            </div>
          </div>
        );
      })}
      {mails[0]?.mail_type !== 'Draft' && mails[0]?.mail_type !== 'Deleted' && (
        <div className='flex flex-row gap-x-4 items-center mt-auto bg-white  fixed bottom-10'>
          <Button
            onClick={() => {
              setAction('reply');
              setOpened(true);
            }}
            leftIcon={<Backarrow className='w-3 h-3' />}
            variant='gray'
            className='3xl:text-2xl 2xl:text-lg'
          >
            Reply
          </Button>
          <Button
            onClick={() => {
              setAction('replyall');
              setOpened(true);
            }}
            leftIcon={<Backarrow className='w-3 h-3' />}
            variant='gray'
            className='3xl:text-2xl 2xl:text-lg'
          >
            Reply All
          </Button>
          <Button
            onClick={() => {
              setAction('forward');
              setOpened(true);
            }}
            rightIcon={<Forward className='w-4 h-4' />}
            variant='gray'
            className='3xl:text-2xl 2xl:text-lg'
          >
            Forward
          </Button>
        </div>
      )}
      <Composemail
        opened={opened}
        setOpened={setOpened}
        data={mails[0]}
        action={action}
      />
      <Deletechat
        isModalOpen={isDelete}
        setIsModalOpen={setIsDelete}
        id={mails[0]?.id}
      />
    </div>
  );
};

export default Displayemail;
